import { render, staticRenderFns } from "./MergeCate01Dialog.vue?vue&type=template&id=087060b4"
import script from "./MergeCate01Dialog.vue?vue&type=script&lang=js"
export * from "./MergeCate01Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports